<ng-container *transloco="let convert;">
<trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
  <app-modal [modalId] ="modalId" class="quote-warning-modal">
    <div class="success-content">
      <header class="modal__header mb-3 d-flex align-items-center justify-content-start justify-content-md-center">
        <h1 class="modal__title title ms-2 mb-0" id="success-modal-title" tabindex="-1" #headingElement>
          <i class="allycon-warning warning-icon me-2" aria-hidden="true"></i>
          {{ convert('vehicles.quoteWarningModel.headerText') }}
        </h1>
      </header>
      <div class="modal__content">
        <div class="modal__body">
            <p class="text-center warning-body">
              {{ convert('vehicles.quoteWarningModel.warningMsg') }}
            </p>
          <div class="modal__actions mt-4 text-center">
            <button class="btn btn-primary d-block d-md-inline-block" (click)="confirm()">{{ convert('common.btnYes') }}</button>
            <button class="btn btn-secondary d-block d-md-inline-block" (click)="reject()">{{ convert('common.btnNo') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-close-container">
      <button
        id="close_x_button"
        class="modal__close-btn"
        [attr.aria-label]="convert('common.modalClose')"
        (click)="close()"
        data-track-elem="icon"
        data-track-name="close"
        data-track-trigger="close"
        data-micromodal-close
      >
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>
    </div>
  </app-modal>
</trap-focus>
</ng-container>
